import React, { useEffect, useState } from "react";
import { Tab as TabComponent } from "../../secondary";
import { Button } from "../../primary";
import PropTypes from "prop-types";
import styles from "./detailView.module.scss";
import PatientCard from "../../core/Patients/patientCard";
import { Header } from "../Header";
import { MobileAppRegisterForm } from "../../core/MobileAppRegisterForm/mobileAppRegisterForm";
import { CreateRiskAssessment } from "../../core/Patients";
import { setCreateAssessmentData } from "../../../app/patientSlice";
import { LayoutsDetail } from "../../core/Layouts/layoutsDetail";
import { ContextualSupport } from "../../core/ContextualSupport/contextualSupport";
import { DISCHARGED } from "../../../constants";
import { useDispatch } from "react-redux";
import { CreateWoundPhotoAssessment } from "../../core/Patients/createWoundPhotoAssessment";
import infoIcon from "../../../static/images/info.svg";
import { dateOfBirthDate } from "../../../utils";
import Tooltip from "../Tooltip/tooltip";
import constants from "../../../constants/constants.json";
import { useAdminView } from "../../../hooks/useAdminView";
import { useHistory } from "react-router-dom";

let prevScrollY = 0;

export function DetailView({
  tabList,
  defaultIndex,
  subHeading,
  patientData,
  layouts = false,
  layoutRowData,
  supportView,
  supportViewRowData,
  detailType,
  tabRemove,
  setPatientMoreInfo,
}) {
  const history = useHistory();
  const dispatch = useDispatch();
  const isAdminView = useAdminView();

  /* New Risk Assessment state */
  const [riskAssessmentModal, setRiskAssessmentModal] = useState(false);
  /* Register mobile app modal */
  const [showModal, setShowModal] = useState(false);
  const [checkTempPass, setCheckTempPass] = useState(false);
  const [createWoundPhotoWithoutModal, setCreateWoundPhotoWithoutModal] = useState(false);
  const [scrollDiv, setScrollDiv] = useState(0);
  const [divHeight, setDivHeight] = useState(false);

  const modalOpen = () => {
    setShowModal(true);
    setCheckTempPass(true);
  };
  const modalClose = () => {
    setShowModal(false);
    setCheckTempPass(false);
  };

  /* New Risk assessment modal open */
  const newRiskAssessmentOpen = () => {
    setRiskAssessmentModal(true);
  };
  /* For closing the Risk modal */
  const newRiskAssessmentClose = () => {
    setRiskAssessmentModal(false);
  };

  useEffect(() => {
    if (detailType === "Patients") {
      dispatch(setCreateAssessmentData("reset"));
    }
  }, [detailType, dispatch]);

  const callAssessMentWithoutPhoto = () => {
    let payload = {
      uuId: null,
      picture: null,
      isWoundWithoutPhoto: 1,
    };
    dispatch(setCreateAssessmentData(payload));
    setCreateWoundPhotoWithoutModal(true);
  };

  const handleScroll = () => {
    const currentScrollY = window.scrollY;
    prevScrollY = currentScrollY;
    setScrollDiv(currentScrollY);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (scrollDiv > 20) {
      setDivHeight(true);
    } else {
      setDivHeight(false);
    }
  }, [scrollDiv]);

  return (
    <div className="">
      {/* Tabs */}
      <Header heading={isAdminView ? "Admin" : ""} subHeading={isAdminView ? subHeading : ""} />
      {/* Patient header only on Patient Management Screen */}
      {subHeading === "Patient Management" && (
        <div className={`col-12 px-0 ${styles.patient_details_blk} pb-3`} style={{ position: "sticky", top: "0", zIndex: "999" }}>
          <PatientCard modalOpen={modalOpen} divHeight={divHeight} setPatientMoreInfo={setPatientMoreInfo} hasRegisterPatient={true} />
        </div>
      )}
      {/* Patient header only on wound assessment and wound profile pages */}
      <div className="col-12 px-0" style={{ position: "sticky", top: "0", zIndex: "999" }}>
        {!isAdminView && <PatientCard modalOpen={modalOpen} divHeight={divHeight} setPatientMoreInfo={setPatientMoreInfo} hasMoreInfo={true} />}
      </div>

      <div className={`col-12 ${styles.wound_address} d-flex flex-row-reverse`}>
        {/* Register Patient for Mobile and New Assessment */}
        <div className={`pt-3  ${styles.ipad_wound}`}>
          <div className="d-flex justify-content-center align-items-center">
            {!isAdminView && [
              <>
                <div className="d-inline mr-2">
                  {patientData?.statusInfo?.status === DISCHARGED && (
                    <Tooltip
                      placement="left"
                      content={`${constants.patient.patientDischarged} ${dateOfBirthDate(patientData?.statusInfo?.dischargeDate)}`}
                    >
                      <img src={infoIcon} alt="info" />
                    </Tooltip>
                  )}
                </div>
                <div className="d-inline mr-2">
                  {patientData && patientData?.skipPhoto === 1 && patientData?.moreInfo?.ne1WMSStatus === 1 && (
                    <Button
                      type={"button"}
                      value={"Wound assessment without photo"}
                      classes={{ className: `btn ${styles.btn_custom} ${styles.btn_mobile}` }}
                      disabled={patientData?.statusInfo?.status === DISCHARGED}
                      onClick={() => callAssessMentWithoutPhoto()}
                    />
                  )}
                  {createWoundPhotoWithoutModal && (
                    <CreateWoundPhotoAssessment
                      modalClose={setCreateWoundPhotoWithoutModal}
                      reEval={false}
                      assessmentId={""}
                      currentWoundPhoto={false}
                      existingAssessment={false}
                      patientId={patientData?.ne1Id}
                      isWoundWithoutPhoto={1}
                    />
                  )}
                </div>
                <div className="d-inline">
                  <div className="btn-group">
                    {patientData?.moreInfo?.ne1WMSStatus === 1 && (
                      <Button
                        type={"button"}
                        classes={{ className: `btn ${styles.btn_new_risk}` }}
                        id="newRiskAssess"
                        onClick={() => newRiskAssessmentOpen()}
                        disabled={patientData?.statusInfo?.status === DISCHARGED}
                      >
                        Risk assessment
                      </Button>
                    )}
                  </div>
                </div>
              </>,
            ]}
          </div>
        </div>
      </div>
      {!layouts && !supportView && <TabComponent tabList={tabList} defaultIndex={defaultIndex} tabRemove={tabRemove} />}
      {showModal && <MobileAppRegisterForm modalOpen={showModal} modalClose={modalClose} checkTempPass={checkTempPass} />}
      {layouts && <LayoutsDetail layoutRowData={layoutRowData} history={history} />}
      {supportView && <ContextualSupport supportViewRowData={supportViewRowData} />}
      {/* Create Risk Assessment modal */}
      {riskAssessmentModal && <CreateRiskAssessment modalClose={newRiskAssessmentClose} />}
    </div>
  );
}

DetailView.propTypes = {
  tabList: PropTypes.array,
  defaultIndex: PropTypes.number,
  layouts: PropTypes.bool,
  layoutRowData: PropTypes.object,
  supportView: PropTypes.bool,
};
